import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Apple's Ping is a big pile of steaming dung",
  "description": "",
  "published": "2010-09-03T00:00:00.000Z",
  "redirect_from": ["/blog/apples-ping-is-a-big-pile-of-steaming-dung/swizec/1444"],
  "categories": "Apple, ITunes Store, Last.fm, ping, Social network, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few days ago `}<a parentName="p" {...{
        "href": "http://www.apple.com",
        "title": "Apple"
      }}>{`Apple`}</a>{` released a social network. Gee, how bloody creative of them and they used to be so cool. There are enough social networks, too many actually. But I digress.`}</p>
    <p>{`Yesterday when I updated iTunes and got the slightly odd new version (what's with the vertical window buttons anyway?) there was no Ping in sight. Very well then, failed already as predicted by my tweet?`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/09/Screen-shot-2010-09-03-at-1.19.39-PM.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/09/Screen-shot-2010-09-03-at-1.19.39-PM.png",
          "alt": null,
          "title": "Screen shot 2010-09-03 at 1.19.39 PM"
        }}></img></a></p>
    <p>{`Well today when I opened iTunes again. There it was! Let's go click that bad boy.`}</p>
    <p>{`The first screen was pretty nice, some blahblahblah about how this is a social network and can do socially stuff. Create account!`}</p>
    <p>{`Ok, first thing that's a bit odd is that my Ping account is the same as my `}<a parentName="p" {...{
        "href": "http://itunes.com",
        "title": "ITunes Store"
      }}>{`iTunes store`}</a>{` account. Luckily I have a slightly hacked one so I can use the US store, otherwise Ping wouldn't even exist for me.`}</p>
    <p><strong parentName="p">{`Fail #1`}</strong>{` - only exists for US people like I suddenly woke up in the middle ages.`}</p>
    <p>{`Another thing that strook me as odd was setting up an avatar:`}<a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/09/Screen-shot-2010-09-03-at-1.17.32-PM.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/09/Screen-shot-2010-09-03-at-1.17.32-PM.png",
          "alt": null,
          "title": "Screen shot 2010-09-03 at 1.17.32 PM"
        }}></img></a></p>
    <p>{`I can swallow the fact there's no Gravatar support but what's this nonsense about my avatar being `}<em parentName="p">{`approved!?`}</em>{` What the flying fuck is going on here?`}</p>
    <p>{`Then there's this lovely tidbit about being forced to choose a whole of three genres of music that I listen to and being forced to choose between a very poor variety of stuff.`}<a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/09/Screen-shot-2010-09-03-at-1.17.23-PM.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/09/Screen-shot-2010-09-03-at-1.17.23-PM.png",
          "alt": null,
          "title": "Screen shot 2010-09-03 at 1.17.23 PM"
        }}></img></a></p>
    <p><strong parentName="p">{`Fail #2`}</strong>{` - nobody likes more than three genres and certainly nobody listens to Metal, Punk, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Alternative_rock",
        "title": "Alternative rock"
      }}>{`Alternative Rock`}</a>{`, Punk-Rock, Cabaret, Swing, Folk and so on. Just the top10 chart on `}<a parentName="p" {...{
        "href": "http://Last.fm",
        "title": "Last.fm"
      }}>{`last.fm`}</a>{` lists stuff from at least 6 different genres, most of them not on this list.`}</p>
    <p>{`Coming to terms with the uselessness of this profile creation screen I finally clicked "Continue" and was greeted with this little ditty:`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/09/Screen-shot-2010-09-03-at-1.29.51-PM.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/09/Screen-shot-2010-09-03-at-1.29.51-PM.png",
          "alt": null,
          "title": "Screen shot 2010-09-03 at 1.29.51 PM"
        }}></img></a>{`Sure, alright, I have to allow them to scrobble what I like. This makes sense. But what the hell!? They ... they aren't scrobbling what I'm actually listening to? Just what I'm ... buying? What the fuck Apple? Don't you realise the last time I bought any music was a few years ago and even that was only after I had been a fan of the artist for a few years and only really considered that CD merchandise?`}</p>
    <p>{`That's `}<strong parentName="p">{`Fail #3`}</strong>{` right there - need to buy/rate/review stuff through the iTunes store for Ping to do anything.`}</p>
    <p>{`And then, then I was greeted by the most hilarious thing ever:`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/09/Screen-shot-2010-09-03-at-1.33.27-PM.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/09/Screen-shot-2010-09-03-at-1.33.27-PM.png",
          "alt": null,
          "title": "Screen shot 2010-09-03 at 1.33.27 PM"
        }}></img></a>{`Quite obviously they recommended some weird stuff. Ok, granted, I like Linkin Park. Good guess. But Katy Perry? No, good boobs, bad music. `}<a parentName="p" {...{
        "href": "http://www.ladygaga.com/",
        "title": "Lady Gaga"
      }}>{`Lady GaGa`}</a>{`? LoL! And U2? Not really a fan, some songs are good, but meh. And I have no idea who `}<a parentName="p" {...{
        "href": "http://www.yo-yoma.com/",
        "title": "Yo-Yo Ma"
      }}>{`Yo-Yo Ma`}</a>{` and Jack Johnson even are.`}</p>
    <p>{`This is a problem that Ping could easily have solved by syncing with my last.fm account that contains the past 4 years of my listening habits.`}</p>
    <p><strong parentName="p">{`Fail #4 `}</strong>{`- obviously commercially inspired music recommendations are obviously lametastic.`}</p>
    <p>{`Ok let's try searching for some of my favourite bands so I can, you know, follow them on Ping and hopefully get something useful out of this pile of steaming cow dung.`}</p>
    <p>{`Cherry Poppin' Daddies - nope, not there`}</p>
    <p>{`The Dresden Dolls - nope`}</p>
    <p><a parentName="p" {...{
        "href": "http://amandapalmer.net",
        "title": "Amanda Palmer"
      }}>{`Amanda Palmer`}</a>{` - nope, just some fat chick, no sign of my beloved Amanda Palmer`}</p>
    <p>{`Inkubus Sukkubus - nope`}</p>
    <p>{`Voltaire - nein`}</p>
    <p>{`Cruxshadows - negative`}</p>
    <p>{`Jack Off Jill - nope`}</p>
    <p>{`Blink-182 - halleluya they're there, but as a ... user? O.o`}</p>
    <p>{`Ok now I found someone and ... where the fuck is my search box? Ah ok, it was a few clicks away.`}</p>
    <p>{`The Doors - nothing`}</p>
    <p>{`Dropkick Murphys - nope`}</p>
    <p>{`Meh I give up, there is nothing worth following on Ping. The artists I do find are labeled as users and everybody knows it's not really them there, it's some automated bot thing to keep us notified of their stuff. But none of the artists I'm actually listening to are there ...`}</p>
    <p><strong parentName="p">{`Fail #5`}</strong>{` - Ping is empty. There are no artists or anything of worth following.`}</p>
    <p>{`I'm going to give Ping the benefit of the doubt. They're just having a bit of a cold start problem and nobody at Apple was smart enough to put at least placeholders for some of the most popular bands/artists of recent decades on there. Even `}<a parentName="p" {...{
        "href": "http://www.marilynmanson.com",
        "title": "Marilyn Manson"
      }}>{`Marilyn Manson`}</a>{`, Iron Maidden and Offspring aren't there ...`}</p>
    <p>{`Oh and here are some more fails:`}</p>
    <p><strong parentName="p">{`Fail #6 `}</strong>{`- Everything is locked in iTunes, you can't send music to people, can't use other players, nothing. It's just plain old locked to the single worts music player in the history of music players`}</p>
    <p><strong parentName="p">{`Fail #7`}</strong>{` - can only invite via Email, who cares about twitter and facebook where my social network actually is? Yeah, nobody cares about that`}</p>
    <p><strong parentName="p">{`Fail #8 `}</strong>{`- no integration with anything. at all. Last.fm would make sense, but at least Twitter and Facebook? Anyone? Yeah I didn't think so. Who uses that crap huh?`}</p>
    <p><strong parentName="p">{`Fail #9`}</strong>{` - oh yeah, there's already a `}<a parentName="p" {...{
        "href": "http://ping.fm/"
      }}>{`ping.fm`}</a>{`, which, coincidentally, is a social network for music that integrates with stuff and works pretty well from what I heard`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=ffb7f017-5402-4e8f-9ce4-f22d785e005b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      